module.exports = __webpack_public_path__ + "img/right_door.dd473ed3.png";